export class Region {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly countryCode: string,
  ) {}
}
